// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'
import * as sets from './sets'

// NOTE - this assumes that all db search forms will follow the same convention
// eg. 'antenna-db-search'.
// if a DB search form is added which doesn't follow this convention, the form
// will not be dynamically reset when user navigates away from the subtree.

const clearDbSearchForm = (formName = '') => (dispatch, getState) => {
  // get the unit type from the user's default
  const unitType = getState().user.getIn(['defaultUnitType', 'unitType'])
  const dbSet = formName.split(/-/)[0]

  try {
    // based on the db set, generate a set of default values for the form
    const initialValues = sets[dbSet].getInitialValues(unitType)
    // then reinitialize the form back to its original state
    dispatch(initialize(formName, initialValues))
  } catch (err) {
    // user should never be able to get here.
    // this would be due to a mapping issue in 'sets'
    console.warn(err)
  }
}

export default clearDbSearchForm
